import { render, staticRenderFns } from "./auHappenning.vue?vue&type=template&id=136d53ea&scoped=true"
import script from "./auHappenning.vue?vue&type=script&lang=js"
export * from "./auHappenning.vue?vue&type=script&lang=js"
import style0 from "./auHappenning.vue?vue&type=style&index=0&id=136d53ea&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136d53ea",
  null
  
)

export default component.exports